import React from "react";
import {
  View,
  Image,
  StyleSheet,
  useWindowDimensions,
  Platform,
} from "react-native";
import { NormalText, PrimaryButton } from "../../../common/native";
import { Picture } from "../../../../assets";
import { useNavigate } from "react-router-dom";

const GalleryEmpty: React.FC = () => {
  const { width, height } = useWindowDimensions();
  const isMobile = Math.min(width, height) < 644;

  const navigate = useNavigate();

  return (
    <View style={{ gap: 20, marginTop: 30 }}>
      <NormalText
        text={"Lets create your first Before-After"}
        style={{ fontSize: 20, textAlign: "center", marginHorizontal: "auto" }}
      />
      <View
        style={[
          styles.imageAndVideoContainer,
          isMobile ? styles.column : styles.row,
        ]}
      >
        <Image
          source={{
            uri: "https://clinic-os.com/user-app-assets/gallery-empty.png",
          }}
          style={[styles.media, { width: isMobile ? "100%" : "50%" }]}
          resizeMode="contain"
        />
        {Platform.OS === "web" ? (
          <video
            src="https://clinic-os.com/user-app-assets/gallery-empty.mp4"
            style={{ ...styles.media, width: isMobile ? "100%" : "50%" }}
            autoPlay
            loop
            muted
            playsInline
            controls
          />
        ) : null}
      </View>
      <View style={{ marginHorizontal: "auto" }}>
        <PrimaryButton
          text={"Get Started"}
          roundBorderRadius
          icon={<Picture />}
          onPress={() => {
            navigate("/before-afters");
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  imageAndVideoContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    gap: 20,
  },
  row: {
    flexDirection: "row",
  },
  column: {
    flexDirection: "column",
  },
  media: {
    maxWidth: 500,
    aspectRatio: 1,
  },
});

export default GalleryEmpty;
